module.exports = __webpack_public_path__ + "60dfec18c9319a21d2c63028733f0308.png";